export class ImportacionFilter {
   emisorId: string;
   sucursalId: string;
   fechaDesde: string;
   fechaHasta: string;
   origen: string = "";
   nombreUsuario: string;
}
